export default __webpack_public_path__ + "static/media/back.21ebedd1.svg";